"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _useMediaQueriedProperties = require("./useMediaQueriedProperties");

var _useTheme2 = _interopRequireDefault(require("./useTheme"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function transformSpacingProperty(spacing, property) {
  if (typeof property === 'number') {
    return spacing(property);
  }

  if (Array.isArray(property)) {
    var isNumeric = property.every(function (p) {
      return typeof p === 'number';
    });

    if (isNumeric) {
      return spacing.apply(void 0, (0, _toConsumableArray2.default)(property));
    }
  }

  return property;
}

function useSpacingProperty(name, property) {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      breakpoint = _useTheme.breakpoint;

  if ((0, _typeof2.default)(property) === undefined) {
    return {};
  }

  if ((0, _useMediaQueriedProperties.isMediaQueriedProperty)(property)) {
    var breakpoints = Object.keys(property);
    var rules = breakpoints.map(function (bp) {
      var value = transformSpacingProperty(spacing, property[bp]);
      return (0, _defineProperty2.default)({}, breakpoint.up(bp), (0, _defineProperty2.default)({}, name, value));
    });
    return rules;
  }

  return (0, _defineProperty2.default)({}, name, transformSpacingProperty(spacing, property));
}

__signature__(useSpacingProperty, "useTheme{{ spacing, breakpoint }}", function () {
  return [_useTheme2.default];
});

var _default = useSpacingProperty;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(transformSpacingProperty, "transformSpacingProperty", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/useSpacingProperty.ts");
  reactHotLoader.register(useSpacingProperty, "useSpacingProperty", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/useSpacingProperty.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/useSpacingProperty.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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